module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../../../node_modules/babel-loader/lib/index.js!./Container.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/StaticPage/Enterprise/Container.js
// module id = 1296
// module chunks = 58